import { gql } from '@apollo/client';
export const folderPickerQuery = gql `
  query folderPicker(
    $entryId: ID!
    $withEntry: Boolean!
    $parentId: ID!
    $skipAncestors: Boolean!
    $limit: Int!
    $offset: Int!
    $showSignRequestStatus: Boolean!
  ) {
    entry: fileSystemEntry(id: $entryId) @include(if: $withEntry) {
      id
      sourceId
      parentId
      name
      depth
      kind
    }

    ancestors: fileSystemAncestors(id: $parentId) @include(if: $skipAncestors) {
      id
      sourceId
      name
      depth
    }

    folder: fileSystemFolder(id: $parentId) {
      id
      sourceId
      parentId
      name
      depth
      kind

      acl: acls {
        id
        userId
        actions
      }

      teamAcls {
        id
        teamId
        actions
      }
    }

    children: fileSystemEntries(
      where: { parentId: { eq: $parentId }, kind: { neq: GUIDANCE } }
      orderBy: { name: asc }
      limit: $limit
      offset: $offset
    ) {
      id
      sourceId
      parentId
      name
      depth
      kind
      acl: acls {
        id
        userId
        actions
      }
      teamAcls {
        id
        teamId
        actions
      }
      ... on FileSystemDocument {
        id
        type
        files {
          id
          path
          mimeType
          name
          size
          signed(name: "entry") {
            url
          }
        }
        lastSignRequest @include(if: $showSignRequestStatus) {
          id
          status
        }
      }
    }
  }
`;
